import { render, staticRenderFns } from "./arrive.vue?vue&type=template&id=fa9e7050&scoped=true&lang=true"
import script from "./arrive.vue?vue&type=script&lang=js"
export * from "./arrive.vue?vue&type=script&lang=js"
import style0 from "./arrive.vue?vue&type=style&index=0&id=fa9e7050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9e7050",
  null
  
)

export default component.exports